// extracted by mini-css-extract-plugin
module.exports = {"error":"TextError_error__8vwL7"};